var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"home app-content"},[(_vm.wsConfig)?_c('router-view'):_vm._e(),(!_vm.wsConfig)?_c('div',[_c('p',[_vm._v("Loading workspace...")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }